import { FilterIcon } from '@pmi/dsm-react/dist/components/icons/16';
import React from 'react';
import styles from './filterByBlock.module.scss';

export interface FilterByProps {
  filterElements?: React.ReactNode[];
}

export default function FilterBy({ filterElements = [] }: FilterByProps) {
  return (
    <div className={`${styles.filterContainerBox} mb-3`}>
      <div className={`${styles.filterText} py-sm-0`}>
        <FilterIcon fontSize="sm" className="me-1" />
        Filter by
      </div>
      <div className={styles.filterElements}>
        {filterElements.length > 0 &&
          filterElements.map((el, index: number) => (
            <div
              className="d-block"
              key={`filterBY${index.toString()}-${new Date().toTimeString()}`}
            >
              {el}
            </div>
          ))}
      </div>
    </div>
  );
}
